module.exports = __webpack_public_path__ + "static/assets/498b3c8f6fc104d436af55c02a008a61.svg";